import React from 'react';
import PropTypes from 'prop-types';

/** What Run all checks / Run quality does, said in the question before it. */
export const RUN_DETAIL = 'Each one runs its tests, lint, secrets, vulnerabilities and licences checks in its sandbox, as its own Quality tab does. It can take a few minutes.';

/**
 * How far a workspace quality run is (useQualityRuns): "Running the checks: 1 of 3 done" while it runs, then which
 * projects could not be checked and why, or that every one was.
 */
export default function QualityRunStatus({ checks }) {
  const { summary, active } = checks;
  if (!summary) { return null; }
  const { total, ended, failed, timedOut } = summary;
  const projects = (count) => `${count} project${count === 1 ? '' : 's'}`;
  return (
    <div className="ws-tools" data-testid="ws-quality-run" role={!active && failed.length ? 'alert' : 'status'}>
      {active && <span className="ws-chip is-info">Running the checks: {ended} of {total} done</span>}
      {!active && (
        <span className={`ws-chip is-${failed.length ? 'bad' : 'ok'}`}>
          {failed.length === 0 && timedOut.length === 0 && `Checks ran for ${projects(total)}.`}
          {(failed.length > 0 || timedOut.length > 0) && `Checks ran for ${projects(total - failed.length - timedOut.length)} of ${total}.`}
        </span>
      )}
      {failed.map((entry) => <span className="ws-muted" key={entry.name}>{entry.name}: {entry.error}</span>)}
      {timedOut.map((entry) => <span className="ws-muted" key={entry.name}>{entry.name}: still running, see its Quality tab</span>)}
      {!active && <button className="ws-link" onClick={checks.clear} type="button">Dismiss</button>}
    </div>
  );
}

QualityRunStatus.propTypes = { checks: PropTypes.object.isRequired };
